import { Badge, Box, IconButton, Tooltip, useTheme } from '@mui/material';
import { MouseEventHandler } from 'react';

import { MessageChatCircleIcon } from '@/assets/icons/MessageChatCircleIcon';
import { useChatWidget } from '@/context/ChatWidgetContext';

interface ChatBubbleProps {
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const ChatBubble: React.FC<ChatBubbleProps> = ({ onClick }) => {
  const theme = useTheme();
  const { state, toggleChat } = useChatWidget();

  const handleClick: MouseEventHandler<HTMLButtonElement> = event => {
    toggleChat();
    if (onClick) {
      onClick(event);
    }
  };

  // Don't render the bubble when chat is open
  if (state.isOpen) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 1050,
      }}
    >
      <Tooltip title="Chat with us" arrow placement="left">
        <Badge
          badgeContent={state.unreadCount}
          color="primary"
          overlap="circular"
          invisible={state.unreadCount === 0}
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '0.75rem',
              fontWeight: 600,
              minWidth: 20,
              height: 20,
              right: 3,
              top: 3,
            },
          }}
        >
          <Box
            sx={{
              position: 'relative',
              width: 60,
              height: 60,
            }}
          >
            <IconButton
              onClick={handleClick}
              aria-label="Open chat"
              sx={{
                position: 'relative',
                zIndex: 2,
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.common.white,
                width: 60,
                height: 60,
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
                transition: 'transform 0.2s ease-in-out',
                '&:hover': {
                  backgroundColor: theme.palette.primary.main,
                  transform: 'scale(1.05)',
                },
              }}
            >
              <MessageChatCircleIcon sx={{ fontSize: 28 }} />
            </IconButton>
          </Box>
        </Badge>
      </Tooltip>
    </Box>
  );
};

export default ChatBubble;
